import { experienceApiClient } from '@/config/httpClients';
import type { QuoteSummary, QuoteSummaryRequest } from './schemas';

const getQuoteSummary = async ({
  quoteSummaryRequest,
}: {
  quoteSummaryRequest: QuoteSummaryRequest;
}): Promise<QuoteSummary> => {
  const response = await experienceApiClient
    .post('v1/product-catalog/quote-summary', {
      json: quoteSummaryRequest,
    })
    .json<QuoteSummary>();

  return response;
};

export { getQuoteSummary };
